import { render, staticRenderFns } from "./overviewBoxGroup.vue?vue&type=template&id=636fe945&"
import script from "./overviewBoxGroup.vue?vue&type=script&lang=js&"
export * from "./overviewBoxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports